import { autoinject, bindable, customAttribute } from 'aurelia-framework';
import { includes, noop } from 'lodash';

@customAttribute('sync-scroll')
@autoinject
export class SyncScroll {
	@bindable targetSelector: string;
	@bindable axis: string;

	constructor(private element: Element) {	}

	attached() {
		const targetElement = document.querySelector(this.targetSelector);
		if(!targetElement) {
			throw Error(`No element found with selector: ${this.targetSelector}`);
		}

		let actionXaxis = noop;
		let actionYaxis = noop;
		const selectedAxes = this.axis.toLowerCase();

		if(includes(selectedAxes, "x")) {
			actionXaxis = () => (<HTMLElement>this.element).style.left = `-${targetElement.scrollLeft}px`;
		} 
		if(includes(selectedAxes, "y")) {
			actionYaxis = () => (<HTMLElement>this.element).style.top = `-${targetElement.scrollTop}px`;
		}

		targetElement.addEventListener("scroll", () => {
			actionXaxis();
			actionYaxis();
		}, false);
	}
}
